import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SettingsService} from "../../../../site-preferences/services/settings-service.service";

export class FulfillmentSettingsPanelTemplateComponent implements IController {

  settings: any;
  isLinesView: boolean;
  panelRef: any;

  public settingsCopy: any;
  public enabledSections: any;
  public packageCustomFieldsColumns?: any;

  /* @ngInject */
  constructor() {

  }

  $onInit() {
    this.settingsCopy = angular.copy(this.settings);
    this.enabledSections = {
      columns: true,
      dynamicTableColumns: false,
      packageDynamicColumns: false,
      viewSettings: false
    }
  }

  onChangeColumns(columnKey, isEnabled) {
    this.settingsCopy.columns[columnKey].enabled = isEnabled;
  }

  onChangeDaysBefore(daysBefore) {
    if (!daysBefore) {
      daysBefore = 0;
    }
    this.settingsCopy.daysBefore = daysBefore;
  }

  onChangeDaysAfter(daysAfter) {
    if (!daysAfter) {
      daysAfter = 0;
    }
    this.settingsCopy.daysAfter = daysAfter;
  }

  onToggleIsOpenColumns(isOpen) {
    this.enabledSections.columns = !this.enabledSections.columns;
  }

  onToggleIsOpenDynamicColumns(isOpen) {
    this.enabledSections.dynamicColumns = !this.enabledSections.dynamicColumns;
  }

  onToggleIsOpenViewSettings(isOpen) {
    this.enabledSections.viewSettings = !this.enabledSections.viewSettings;
  }

  onToggleIsOpenPackageDynamicColumns(isOpen) {
    this.enabledSections.packageDynamicColumns = !this.enabledSections.packageDynamicColumns;
  }


  onViewAsChange(isLinesView) {
    this.settingsCopy.isLinesView = isLinesView;
  }

  onSubmit() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Submit', this.settingsCopy);
  }

  onReset() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Reset');
  }

  onCancel() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Cancel');
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentSettingsPanelTemplate', {
    bindings: {
      settings: '<',
      isLinesView: '<',
      panelRef: '<'
    },
    template: require('./fulfillment-settings-panel-template.html').default,
    controller: FulfillmentSettingsPanelTemplateComponent
  });
